<template>
	<div>
		<div class="d-flex align-items-center justify-content-between mb16">
			<Icon v-if="isMobile" name="arrow-left" class="pointer" @click="close" />
			<h4 class="text-black neue fw-medium mb-0 lh28 pr24 fsp20" :class="{ 'flex-grow-1 text-center': isMobile }">
				{{ $t('views.Echeck.New.1') }}
			</h4>
			<Icon v-if="!isMobile" name="close" class="pointer" @click="close" />
		</div>
		<div class="bg-white rounded12" :class="{ 'p24': !isMobile }">
			<div class="d-flex flex-column align-items-center gap24 mb40">
				<div class="result-icon-outer">
					<div class="result-icon-inner">
						<Icon name="double-check" size="c24" />
					</div>
				</div>
				<div class="d-flex flex-column align-items-center gap12">
					<h3 class="fsp32 neue fw-medium mb-0 text-center">{{ $t('views.Echeck.New.11') }}</h3>
					<p class="fsp16 neue-roman lh24 text-center mb-0 result-hint">{{ $t('views.Echeck.New.13') }}</p>
				</div>
			</div>
			<div class="result-card mb40">
				<div v-for="(row, index) in visibleList" :key="index" class="result-card-item">
					<div class="d-flex align-items-center justify-content-between">
						<span class="fsp14 neue-roman lh20 result-label">{{ $t('views.Echeck.New.8') }}</span>
						<span class="fsp14 neue fw-medium lh20 text-black">{{ row.serial }}</span>
					</div>
					<div class="d-flex align-items-center justify-content-between">
						<span class="fsp14 neue-roman lh20 result-label">{{ $t('views.Echeck.New.9') }}</span>
						<span class="fsp14 neue fw-medium lh20 text-black">{{ row.number }}</span>
					</div>
					<div class="d-flex align-items-center justify-content-between">
						<span class="fsp14 neue-roman lh20 result-label">{{ $t('views.Echeck.New.10') }}</span>
						<span class="fsp14 neue fw-medium lh20 text-black">{{ row.secret }}</span>
					</div>
				</div>
				<div v-if="resultList.length > 2" class="show-all-btn" @click="showAll = !showAll">
					<span class="fsp12 neue fw-medium">{{ showAll ? $t('views.Echeck.New.15') : $t('views.Echeck.New.14') }}</span>
					<Icon name="chevron-down" size="c16" :class="{ 'rotate-180': showAll }" />
				</div>
			</div>
			<div class="d-flex gap16" :class="{ 'mobile-modal-buttons': isMobile }">
				<Button
					@click="close"
					:name="$t('views.Echeck.New.6')"
					class="h48 equal-width"
					type="btn-outline-grey"
				/>
				<Button
					@click="ExportEcheck"
					:name="$t('views.Echeck.New.12')"
					class="h48 equal-width"
					type="btn-warning"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import Icon from '@/components/icons/Icon';
import Button from '@/components/service/Button';

export default {
	components: {
		Icon,
		Button,
	},
	props: {
		close: [Function],
	},
	data() {
		return {
			showAll: false,
		};
	},
	computed: {
		isMobile() {
			return this.$store.state.resize.w <= 768;
		},
		resultList() {
			return this.$store.state.modal.content?.result_list || [];
		},
		resultString() {
			return this.$store.state.modal.content?.result_string || '';
		},
		visibleList() {
			return this.showAll ? this.resultList : this.resultList.slice(0, 2);
		},
	},
	methods: {
		// Экспорт клиентский: у msEcheck нет серверной ручки выгрузки.
		// Секрет показывается один раз — даём пользователю скачать файл.
		ExportEcheck() {
			const header = [
				this.$t('views.Echeck.New.8'),
				this.$t('views.Echeck.New.9'),
				this.$t('views.Echeck.New.10'),
			].join(';');
			const lines = this.resultList.map(row => [row.serial, row.number, row.secret].join(';'));
			const content = [header, ...lines].join('\n');
			const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
			const url = URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = url;
			link.download = 'echecks.csv';
			link.click();
			URL.revokeObjectURL(url);
		},
	},
};
</script>

<style lang="scss" scoped>

.result-icon-outer {
	width: 64px;
	height: 64px;
	border-radius: 50%;
	background-color: $menu-bg;
	background-color: color-mix(in srgb, #{$menu-bg} 10%, transparent);
	display: flex;
	align-items: center;
	justify-content: center;
}

.result-icon-inner {
	width: 48px;
	height: 48px;
	border-radius: 50%;
	background-color: $menu-bg;
	display: flex;
	align-items: center;
	justify-content: center;
}

.result-hint {
	color: #000;
}

.result-card {
	background: $bg-light-blue;
	border: 1px solid $primary-stroke;
	border-radius: 8px;
	padding: 16px;
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.result-card-item {
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.result-card-item + .result-card-item {
	padding-top: 12px;
	border-top: 1px solid $primary-stroke;
}

.result-label {
	color: $primary-grey;
	width: 168px;
	flex-shrink: 0;
}

.show-all-btn {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	padding: 8px;
	cursor: pointer;
	color: $menu-bg;
	text-decoration: underline;

	:deep(path) {
		stroke: $menu-bg !important;
		opacity: 1 !important;
	}
}

:deep(.rotate-180) {
	transform: rotate(180deg);
}
</style>
